<template>
  <div>
    <LayoutHeader
      :topColor="topColor"
      bannerType="header user"
      :userActive="true"
      :height="380"
    />
    <div class="container">
      <div class="top">
        <div>个人资料修改</div>
      </div>

      <a-form
        class="editForm"
        :form="form"
        @submit="handleSubmit"
        labelAlign="left"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-item label="原始密码">
          <a-input
            v-decorator="[
              'password_original',
              {
                rules: [{ required: true, message: '原始密码为必填!' }],
              },
            ]"
            :type="firstType"
            placeholder=""
          >
          </a-input>
          <img
            class="eyes"
            :src="firstImg"
            @click="changeEye('first')"
            alt=""
          />
        </a-form-item>

        <a-form-item label="新密码">
          <a-input
            v-decorator="[
              'password_new',
              {
                rules: [{ required: true, message: '新密码为必填!' }],
              },
            ]"
            :type="secondType"
            placeholder=""
          >
          </a-input>
          <img
            class="eyes"
            :src="secondImg"
            @click="changeEye('second')"
            alt=""
          />
        </a-form-item>

        <a-form-item label="确认密码">
          <a-input
            v-decorator="[
              'password',
              {
                rules: [
                  { required: true, message: '请确认密码!' },
                  {
                    validator: compareToFirstPassword,
                  },
                ],
              },
            ]"
            :type="thirdType"
            placeholder=""
          >
          </a-input>
          <img
            class="eyes"
            :src="thirdImg"
            @click="changeEye('third')"
            alt=""
          />
        </a-form-item>

        <div>
          <div class="cancel" @click="cancelBtn">取消</div>
          <div class="saveData" html-type="submit" @click="handleSubmit">
            保存
          </div>
        </div>
      </a-form>
    </div>
    <LayoutFooter />
  </div>
</template>

<script>
import UserServices from "../../xx-vue/services/user";
export default {
  data() {
    return {
      topColor: "background-color: rgba(0, 0, 0, 0.3)",
      formData: {},
      labelCol: {
        sm: { span: 2, offset: 6 },
      },
      wrapperCol: {
        sm: { span: 10 },
      },
      firstType: "password",
      secondType: "password",
      thirdType: "password",
      firstVisiable: false,
      secondVisiable: false,
      thirdVisiable: false,
      firstImg: require("../../assets/images/user/yh-icon-visible@2x.png"),
      secondImg: require("../../assets/images/user/yh-icon-visible@2x.png"),
      thirdImg: require("../../assets/images/user/yh-icon-visible@2x.png"),
    };
  },
  mounted() {
    this.initScroll();
  },
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: "editForm" });
  },
  beforeDestroy() {
    document.removeEventListener("scroll", this.listenerFunction);
  },
  methods: {
    //初始化滚动条监听
    initScroll() {
      document.addEventListener("scroll", this.handleScroll, true);
    },
    //监听滚动条移动
    handleScroll() {
      const pageY = window.pageYOffset;
      if (pageY === 0) {
        this.topColor = "background-color: rgba(0, 0, 0, 0.3)";
      } else {
        this.topColor = "background-color: rgb(22,22,22)";
      }
    },
    //表单提交
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields(async (err, values) => {
        if (!err) {
          delete values.password;
          const result = await UserServices.editPwdAsync(values);
          console.log(result);
          if (result.code === 200) {
            this.$message.success("密码修改成功！");
            this.$router.push("/user");
          }
        }
      });
    },
    //确认密码
    compareToFirstPassword(rule, value, callback) {
      const form = this.form;
      if (value && value !== form.getFieldValue("password_new")) {
        callback("两次密码不一致!");
      } else {
        callback();
      }
    },
    changeEye(item) {
      switch (item) {
        case "first":
          this.firstVisiable = !this.firstVisiable;
          if (this.firstVisiable !== true) {
            this.firstImg = require("../../assets/images/login/DL-visible2@2x.png");
            this.firstType = "password";
          } else {
            this.firstImg = require("../../assets/images/login/DL_visible@2x.png");
            this.firstType = "text";
          }
          break;
        case "second":
          this.secondVisiable = !this.secondVisiable;
          if (this.secondVisiable !== true) {
            this.secondImg = require("../../assets/images/login/DL-visible2@2x.png");
            this.secondType = "password";
          } else {
            this.secondImg = require("../../assets/images/login/DL_visible@2x.png");
            this.secondType = "text";
          }
          break;
        case "third":
          this.thirdVisiable = !this.thirdVisiable;
          if (this.thirdVisiable !== true) {
            this.thirdImg = require("../../assets/images/login/DL-visible2@2x.png");
            this.thirdType = "password";
          } else {
            this.thirdImg = require("../../assets/images/login/DL_visible@2x.png");
            this.thirdType = "text";
          }
          break;
      }
    },
    //取消
    cancelBtn(){
      this.$router.push('/user')
    }
  },
};
</script>

<style lang="less" scoped>
.ant-input {
  border: none;
  height: unset;
  background-color: #f6f6f6;
  padding-top: 14px;
  padding-bottom: 14px;
  font-size: 18px;
  color: #989898;
  text-indent: 10px;
}
.ant-input:focus {
  box-shadow: none;
}
.ant-form-item {
  display: flex;
  align-items: center;
}
.container {
  width: 1200px;
  margin: 0 auto;
  padding: 40px 0;
  .top {
    border-bottom: 2px solid #e6e7e8;
    margin-bottom: 24px;
    div {
      margin-left: 20px;
      width: 140px;
      text-align: center;
      font-weight: bold;
      font-size: 18px;
      color: #333333;
      padding-bottom: 10px;
      border-bottom: 2px solid #e24141;
    }
  }

  .editForm {
    margin: 0 auto;
    .eyes {
      width: 20px;
      height: 14px;
      position: absolute;
      right: 0;
      top: 1px;
      right: 18px;
      cursor: pointer;
    }
  }

  .cancel {
    background: url("../../assets/images/user/yh-bt-cancel@2x.png") no-repeat;
    background-size: 100% 100%;
    display: inline-block;
    color: white;
    width: 146px;
    height: 56px;
    line-height: 50px;
    text-align: center;
    cursor: pointer;
    margin-left: 398px;
    margin-top: 96px;
  }

  .saveData {
    background: url("../../assets/images/user/yh-bt-normol@2x.png") no-repeat;
    background-size: 100% 100%;
    display: inline-block;
    color: white;
    width: 146px;
    height: 56px;
    line-height: 50px;
    text-align: center;
    cursor: pointer;
    margin-left: 100px;
    margin-bottom: 122px;
  }
}
</style>
